<app-header></app-header>
<app-banner></app-banner>
<app-service></app-service>
<app-features></app-features>
<app-latestservice></app-latestservice>
<app-cases></app-cases>
<app-facts></app-facts>
<app-team></app-team>
<app-testimonials></app-testimonials>
<app-cta></app-cta>
<app-blogpost></app-blogpost>
<app-footer [layout]="classname" [logo]="ftlogo" [shape]="ftshape" [bgimage]="ftbgimage"></app-footer>
